
import { onMounted, ref } from 'vue';
import log from '@/global/log';
export default {
	setup() {
		let activeTab = ref('스마트밴드 연동');
		let tabPositionTop = ref();
		const contents = [
			{
				category: '스마트밴드 연동',
				title:
					'스마트워치에서 수집된 건강정보로<br>개인 맞춤형 질환 예방',
				subtitle:
					'최고의 기술력과 다양한 경험을 보유한 기술팀이 원활한 서비스 이용을 보장하는 안정적인 연동기술을 제공합니다.',
				img: require('@/assets/images/health_mobile/img1.png'),
			},
			{
				category: '건강정보 기록',
				title:
					'다양한 건강정보 관리를 위한<br>편리한 기록 기능 제공',
				subtitle:
					'디바이스에서 수집되는 정보 외에도 사용자가 편리하게 건강정보를 관리할 수 있고, 입력 결과에 대한 평가 정보를 제시합니다.',
				img: require('@/assets/images/health_mobile/img2.png'),
			},
			{
				category: '건강정보 분석',
				title:
					'다양한 건강분석 정보와<br>서비스 참여정보 제공',
				subtitle:
					'사용자가 본인의 건강생활 활동을 스스로 평가할 수 있도록 지원합니다.',
				img: require('@/assets/images/health_mobile/img3.png'),
			},
			{
				category: '활동 보상',
				title:
					'건강 활동에 대한 보상체계를 구축하여<br>강력한 실천 동기 부여',
				subtitle:
					'지역상황을 고려한 포인트 체계 구성이 가능하고 보상 서비스(지역화폐, 상품권 등)와 연계하여 사업을 진행할 수 있습니다.',
				img: require('@/assets/images/health_mobile/img4.png'),
			},
			{
				category: '다채로운 콘텐츠',
				title:
					'지속적인 서비스 참여를 유도하는<br>다채로운 콘텐츠 제공',
				subtitle:
					'챌린지, 랭킹 기능 등 다양한 콘텐츠로 사용자의 지속적 참여를 유도할 수 있습니다.',
				img: require('@/assets/images/health_mobile/img5.png'),
			},
			{
				category: '건강 이벤트',
				title:
					'지역 주민들간 연대의식을<br>강화할 수 있는 건강 이벤트',
				subtitle:
					'다양한 유형의 이벤트 관리 기능을 지원하여 서비스 참여율과 지역 서비스 이용률을 증대할 수 있습니다.',
				img: require('@/assets/images/health_mobile/img6.png'),
			},
			{
				category: '건강 퀴즈/콘텐츠',
				title:
					'건강생활 습관과 관련된<br>퀴즈 및 콘텐츠 제공',
				subtitle:
					'일주일에 한 번씩 운동, 영양, 비만관리 등 다양한 분야의 건강 퀴즈와 콘텐츠를 제공합니다.',
				img: require('@/assets/images/health_mobile/img7.png'),
			},
			{
				category: '건강관리 서비스',
				title: '다양한 건강관리 서비스 제공',
				subtitle:
					'현재 적용되어있는 홈 트레이닝, 수면 및 명상 서비스 외에도 검증된 헬스케어 서비스를 지속적으로 확대할 예정입니다.',
				img: require('@/assets/images/health_mobile/img8.png'),
			},
		];
		let zoomModalOpen = ref(false);
		let zoomImg = ref();

		function onScroll(top: number, _: any) {
			const tabEl = document.getElementById(
				'tab'
			) as HTMLElement;

			const headerEl = document.querySelector(
				'header'
			) as HTMLElement;

			const headerStyles =
				window.getComputedStyle(headerEl);
			// height 속성을 가져와서 높이를 얻습니다.
			const headerHeight: string =
				headerStyles.getPropertyValue('height');
			// 숫자만 추출하는 정규식 패턴
			const pattern = /\d+/; // 정규식을 사용하여 숫자를 추출
			const matches = headerHeight.match(pattern);
			const headerHeightInt = parseInt(
				matches![0],
				10
			);
			log('headerHeight :' + headerHeightInt);

			if (
				top >
				tabPositionTop.value - headerHeightInt
			) {
				// 요소가 스크롤 최상단에 위치함
				// 원하는 작업 수행

				log('onScroll at content top');
				tabEl.classList.add('fix');
			} else {
				// 요소가 스크롤 최상단에 위치하지 않음
				// 다른 작업 수행
				log('onScroll at news not top');
				tabEl.classList.remove('fix');
			}

			const sections =
				document.getElementsByClassName(
					'content'
				) as unknown as HTMLElement[];
			const length = sections.length;
			log(
				'sections count' + sections.length,
				sections
			);
			for (let i = 0; i < length; i++) {
				const sectionOffset: number =
					sections[i].offsetTop;
				if (
					sectionOffset >=
					top +
						headerHeightInt -
						sections[i].scrollHeight
				) {
					activeTab.value = contents[i].category;
					return;
				}
			}
		}

		// 요소의 스크롤 탑 위치 확인
		function isElementAtTop(
			element: HTMLElement
		) {
			const rect =
				element.getBoundingClientRect();
			return rect.top;
		}

		//탭 스크롤 fn
		function scrollToSection(index: number) {
			const section =
				document.getElementsByClassName(
					'content'
				)[index] as unknown as HTMLElement;

			const layoutEl =
				document.getElementsByClassName(
					'layout'
				) as unknown as HTMLElement[];

			layoutEl[0].scrollTo({
				top: section.offsetTop - 160,
				behavior: 'smooth',
			});

			// if (section) {
			// 	section.scrollIntoView({
			// 		behavior: 'smooth',
			// 	});
			// }
		}

		onMounted(() => {
			const tabEl = document.getElementById(
				'tab'
			) as HTMLElement;
			tabPositionTop.value =
				isElementAtTop(tabEl);
		});

		return {
			activeTab,
			onScroll,
			scrollToSection,
			tabArr: [
				'스마트밴드 연동',
				'건강정보 기록',
				'건강정보 분석',
				'활동 보상',
				'다채로운 콘텐츠',
				'건강 이벤트',
				'건강 퀴즈/콘텐츠',
				'건강관리 서비스',
			],
			contents,
			zoomModalOpen,
			zoomImg,
		};
	},
};
